
import velocity from 'velocity-animate';
import { scrollTo } from 'Models/scroll';

import store from 'Store';

export default function accordion (element) {
    let activeBreakpoints = store.getters.getActiveBreakpoints;

    const baseAccordionSettings = {
        until: false,
        from: false,
        headClass: '.js-accordion__head',
        bodyClass: '.js-accordion__body',
        closeOthers: false,
    };

    const customAccordionSettings = element.dataset.accordionSettings ? JSON.parse(element.dataset.accordionSettings) : {};

    const accordionSettings = { ...baseAccordionSettings, ...customAccordionSettings };

    let accordionInitialized = false;

    const headElements = element.querySelectorAll(accordionSettings.headClass);

    let animating = false;
    let scrollToItem = false;

    function init () {
        // add data-initialized attribute to prevent re-initialization
        if (element.getAttribute('data-initialized')) return;
        element.setAttribute('data-initialized', true);
        toggleAccordion();
        addResizeListener();
    }

    function initAccordion () {
        if (accordionInitialized) return;
        headElements.forEach(headEl => {
            headEl.addEventListener('click', openCloseElement);
        });
        accordionInitialized = true;
    }

    function removeAccordion () {
        if (!accordionInitialized) return;
        headElements.forEach(headEl => {
            headEl.removeEventListener('click', openCloseElement);
        });
        accordionInitialized = false;
    }

    function addResizeListener () {
        store.watch((state) => {
            activeBreakpoints = state.activeBreakpoints;
            toggleAccordion();
        });
    }

    function toggleAccordion () {
        if ((accordionSettings.until && activeBreakpoints.length) || (accordionSettings.from && activeBreakpoints.length)) {
            if (activeBreakpoints.indexOf(accordionSettings.until) < 0 || activeBreakpoints.indexOf(accordionSettings.from) >= 0) {
                initAccordion();
            } else {
                removeAccordion();
            }
        } else {
            initAccordion();
        }

        // scrolls to top of item on mobile
        if (activeBreakpoints.indexOf('tablet') < 0) {
            scrollToItem = true;
        }
    }

    function openCloseElement (e) {
        e.preventDefault();
        e.stopPropagation();
        const target = e.currentTarget;
        const bodyEl = target.parentNode.querySelector(accordionSettings.bodyClass);

        // close all others if setting is true – must have same body and head classes!
        if (accordionSettings.closeOthers) {
            const moduleEl = target.closest('.module');
            moduleEl.querySelectorAll(`${accordionSettings.headClass}.is-open`).forEach(el => {
                if (el !== e.target) {
                    const elBodyEl = el.parentNode.querySelector(accordionSettings.bodyClass);
                    el.classList.remove('is-open');
                    velocity(elBodyEl, 'slideUp', {
                        easing: 'easeOutQuad',
                    });
                }
            });
        }

        if (animating) return;

        if (target.classList.contains('is-open')) {
            target.classList.remove('is-open');
            animating = true;
            velocity(bodyEl, 'slideUp', {
                easing: 'easeOutQuad',
                duration: 400,
                complete: afterAnimation(e.target),
            });
        } else {
            target.classList.add('is-open');
            animating = true;
            velocity(bodyEl, 'slideDown', {
                easing: 'easeOutQuad',
                duration: 400,
                complete: afterAnimation(e.target),

            });
        }
    }

    function afterAnimation (item) {
        setTimeout(() => {
            animating = false;

            if (scrollToItem) {
                setTimeout(() => {
                    scrollTo(item);
                }, 300);
            }
        }, 100);
    }

    init();
}
